module.exports = __webpack_public_path__ + "static/media/aldi8.965f0985.jpg";